import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import { useLayout } from '../../../../context/LayoutContext';
import { useTickets } from '../../../../context/TicketsContext';

const TicketsBoard = () => {
  const { theme } = useLayout();
  const { 
    departments, 
    getTicketCount, 
    navigateToDepartment,
    setIsCreateModalOpen
  } = useTickets();

  // Estadísticas generales
  const ticketsResueltos = 34; // Valores estáticos para ejemplo
  const ticketsReportados = 2;
  const ticketsEnProceso = 1;
  const totalTicketsProceso = 3;

  return (
    <div className={`GM__${theme}-tickets-board`}>
      {/* Header */}
      <div className={`GM__${theme}-tickets-header`}>
        <h1 className={`GM__${theme}-tickets-title`}>Gestión de Tickets</h1>
        <button 
          className={`GM__${theme}-btn-primary`}
          onClick={() => setIsCreateModalOpen(true)}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Crear Ticket
        </button>
      </div>

      {/* Stats Cards */}
      <div className={`GM__${theme}-tickets-stats`}>
        <div className={`GM__${theme}-stat-card GM__${theme}-stat-success`}>
          <div className={`GM__${theme}-stat-content`}>
            <h3>Tickets resueltos</h3>
            <div className={`GM__${theme}-stat-number`}>{ticketsResueltos}</div>
          </div>
          <div className={`GM__${theme}-stat-progress`}></div>
        </div>

        <div className={`GM__${theme}-stat-card GM__${theme}-stat-danger`}>
          <div className={`GM__${theme}-stat-content`}>
            <h3>Reportados</h3>
            <div className={`GM__${theme}-stat-number`}>{ticketsReportados}</div>
          </div>
          <div className={`GM__${theme}-stat-progress`}></div>
        </div>

        <div className={`GM__${theme}-stat-card GM__${theme}-stat-warning`}>
          <div className={`GM__${theme}-stat-content`}>
            <h3>En proceso</h3>
            <div className={`GM__${theme}-stat-number`}>{ticketsEnProceso}/{totalTicketsProceso}</div>
          </div>
          <div className={`GM__${theme}-stat-progress`}></div>
        </div>
      </div>

      {/* Departments Board */}
      <div className={`GM__${theme}-departments-grid`}>
        {departments.map(department => (
          <div 
            key={department.id}
            className={`GM__${theme}-department-card GM__${theme}-department-${department.id}`}
            onClick={() => navigateToDepartment(department.id)}
          >
            <div className={`GM__${theme}-department-header`}>
              <div className={`GM__${theme}-department-icon`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {department.icon === 'box' && <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>}
                  {department.icon === 'activity' && <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>}
                  {department.icon === 'users' && <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>}
                  {department.icon === 'truck' && <path d="M1 3h15v13H1z M16 8h4l3 3v5h-7z"></path>}
                </svg>
              </div>
              <h3 className={`GM__${theme}-department-name`}>{department.name}</h3>
              <button className={`GM__${theme}-add-ticket-btn`}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
              </button>
            </div>
            
            <div className={`GM__${theme}-department-tickets`}>
              {getTicketCount(department.id) === 0 ? (
                <div className={`GM__${theme}-empty-department`}>
                  <p>No hay tickets en esta categoría</p>
                </div>
              ) : (
                <div className={`GM__${theme}-ticket-previews`}>
                  {/* Previsualizaciones de tickets (3 máximo) */}
                  {[1, 2, 3].map(index => (
                    <div key={index} className={`GM__${theme}-ticket-preview`}>
                      <div className={`GM__${theme}-ticket-indicators`}>
                        <span className={`GM__${theme}-indicator GM__${theme}-indicator-low`}></span>
                        <span className={`GM__${theme}-indicator GM__${theme}-indicator-medium`}></span>
                        <span className={`GM__${theme}-indicator GM__${theme}-indicator-high`}></span>
                      </div>
                      <p className={`GM__${theme}-ticket-preview-text`}>
                        título o primer párrafo de párrafo...
                      </p>
                      <div className={`GM__${theme}-ticket-actions`}>
                        <div className={`GM__${theme}-ticket-icons`}>
                          <span className={`GM__${theme}-ticket-icon`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M12 20h9"></path>
                              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                            </svg>
                          </span>
                          <span className={`GM__${theme}-ticket-icon`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="M12 16v-4"></path>
                              <path d="M12 8h.01"></path>
                            </svg>
                          </span>
                          <span className={`GM__${theme}-ticket-icon`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                              <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                          </span>
                        </div>
                        <div className={`GM__${theme}-ticket-date`}>Fecha/hora</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketsBoard;